module.exports = __webpack_public_path__ + "static/media/skill.4d736ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/skill.png
// module id = 307
// module chunks = 0